// Payment and pickup card (snippets/product-extras-card.liquid), owner 2026-10-20: compact rows with theme icons.
// Moves the PayPal, Scalapay, HeyLight and pickup blocks into the card; instalment widgets fold behind "Vedi opzioni".
// Country rules stay with the widgets (HeyLight Italy only, Scalapay its countries).
// PayPal Pay in 3 is our own line (no PayPal script): Italy, EUR, 30-2,000 EUR, follows the selected variant.
(() => {
  const card = document.querySelector('[data-pxc]');
  if (!card || card.dataset.ready) return;
  card.dataset.ready = '1';
  const d = card.dataset;
  const icon = (n) => card.querySelector(`template[data-icon="${n}"]`).innerHTML;
  const row = (name, label) => {
    const r = document.createElement('div');
    r.className = `pxc-row pxc-row-${name}`;
    r.innerHTML = `<span class="pxc-icon">${icon(name)}</span><div class="pxc-body">${label ? `<p class="pxc-label">${label}</p>` : ''}<div class="pxc-slot"></div></div>`;
    card.append(r);
    return r;
  };
  const pay = row('pay', d.pay);
  const pickup = row('pickup', '');
  const trust = document.createElement('div');
  trust.className = 'pxc-row pxc-row-trust';
  trust.innerHTML = `<span class="pxc-trust-item"><span class="pxc-icon">${icon('secure')}</span>${d.secure}</span><span class="pxc-trust-item"><span class="pxc-icon">${icon('returns')}</span>${d.returns}</span>`;
  card.append(trust);
  const btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'pxc-toggle'; btn.setAttribute('aria-expanded', 'false');
  btn.innerHTML = `${d.payMore}<span class="pxc-chevron">${icon('chevron')}</span>`;
  btn.addEventListener('click', () => { pay.classList.toggle('is-open'); btn.setAttribute('aria-expanded', String(pay.classList.contains('is-open'))); });
  pay.querySelector('.pxc-label').append(' ', btn);
  const pp = document.createElement('p');
  pp.className = 'pxc-pp';
  const ppRender = (cents) => {
    const ok = d.country === 'IT' && d.ppCurrency === 'EUR' && cents >= 3000 && cents <= 200000;
    pp.hidden = !ok;
    if (!ok) return;
    const amount = new Intl.NumberFormat(d.ppLocale || 'it', { style: 'currency', currency: 'EUR' }).format(Math.ceil(cents / 3) / 100);
    // The translated text starts with "PayPal" (or "PayPal :"): the official logo takes its place.
    const text = d.ppText.replace(/^PayPal\s*:?\s*/, '').replace('{{ amount }}', `<strong>${amount}</strong>`);
    pp.innerHTML = `${icon('paypal')} ${text} <a href="https://www.paypal.com/it/digital-wallet/ways-to-pay/buy-now-pay-later" target="_blank" rel="noopener">${d.ppMore}</a>`;
  };
  ppRender(Number(d.ppPrice));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.productVariantChange, (data) => {
      if (data?.variant && Number.isFinite(data.variant.price)) { ppRender(data.variant.price); grab(); }
    });
  }
  const grab = () => {
    const paySlot = pay.querySelector('.pxc-slot');
    if (!paySlot.contains(pp)) paySlot.prepend(pp);
    const found = [
      document.querySelector('[id*="scalapay_on_site_messaging_widget_block"]'),
      ...[...document.querySelectorAll('.heidi_messaging')].map((h) => h.closest('.product-block') || h),
    ].filter(Boolean);
    found.forEach((el) => { if (!paySlot.contains(el)) paySlot.append(el); });
    paySlot.querySelectorAll('scalapay-widget').forEach((w) => {
      w.setAttribute('alignment', 'left');
      const sh = w.shadowRoot;
      if (sh && !sh.querySelector('style[data-pxc]')) { const st = document.createElement('style'); st.dataset.pxc = '1'; st.textContent = 'article,.flex-nowrap{justify-content:flex-start!important}'; sh.append(st); }
    });
    // Store pickup only makes sense for delivery to Italy (owner 2026-10-20): elsewhere the pickup block is hidden.
    const pk = document.querySelector('pickup-availability');
    if (pk && d.country !== 'IT') pk.style.display = 'none';
    if (pk && !pickup.querySelector('.pxc-slot').contains(pk)) pickup.querySelector('.pxc-slot').append(pk);
    // A block counts only when its app really rendered something here (apps hide themselves by country).
    // Above its limit Scalapay keeps an empty widget (owner 2026-11-02, 11.699 EUR Foil showed "Vedi opzioni" with nothing),
    // so it counts only when its shadow DOM has text.
    const real = (el) => {
      if (getComputedStyle(el).display === 'none') return false;
      const sw = el.querySelector('scalapay-widget');
      if (sw) return !!sw.shadowRoot && [...sw.shadowRoot.childNodes].some((n) => n.nodeName !== 'STYLE' && n.textContent.trim());
      return !!el.querySelector('.heyLight-inline, iframe, [id^="zoid-paypal"]');
    };
    pay.hidden = pp.hidden && !found.some(real);
    pickup.hidden = d.country !== 'IT' || !(pk && pk.textContent.trim());
    card.hidden = false;
  };
  grab();
  const mo = new MutationObserver(grab);
  mo.observe(document.body, { childList: true, subtree: true });
  // Scalapay fills its shadow DOM without touching the page, so the observer does not see it: check again.
  [2000, 5000].forEach((ms) => setTimeout(grab, ms));
  setTimeout(() => { mo.disconnect(); grab(); }, 10000);
})();
